import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import AuthService from '../services/AuthService';
import { useImpersonation, useStudentAccess, useCanViewUndergraduate, useCanViewGraduate, useCanEvaluateUndergraduate, useCanViewUndergraduateApplications, useCanViewGraduateStaff } from './StudentWorkspace';

export default function Home() {
  const impersonation = useImpersonation();
  const canViewUndergraduate = useCanViewUndergraduate();
  const canViewGraduate = useCanViewGraduate();
  const studentAccess = useStudentAccess();
  const canEvaluateUndergraduate = useCanEvaluateUndergraduate();
  const canViewApplications = useCanViewUndergraduateApplications();
  const canViewGraduateStaff = useCanViewGraduateStaff();
  const canManageAdministration = !impersonation && Boolean(AuthService.getCurrentToken()?.canImpersonate);
  const hasStaffWorkspaces = canViewApplications || canViewGraduateStaff || canManageAdministration;
  if (!hasStaffWorkspaces && canViewGraduate && !canViewUndergraduate) return <Navigate to="/graduate" replace />;
  if (!hasStaffWorkspaces && canViewUndergraduate && !canViewGraduate) return <Navigate to="/undergraduate" replace />;
  return <div className="welcome-panel"><h1>Welcome to the Graduation Application</h1>
    <p>{canViewUndergraduate && canViewGraduate ? 'Choose the undergraduate or graduate workspace to create and manage applications.' :
      canEvaluateUndergraduate ? 'Search, review, and update undergraduate graduation applications.' :
      canViewApplications ? 'Search and view undergraduate graduation applications.' :
      'Choose an application workflow from the navigation.'}</p>
    <div className="d-flex flex-wrap gap-3">
      {canViewApplications && <Link className="btn btn-primary" to="/admin/undergraduate">Undergraduate Applications</Link>}
      {canViewGraduateStaff && <Link className="btn btn-primary" to="/admin/graduate">Graduate Applications</Link>}
      {canViewUndergraduate && <Link className="btn btn-primary" to="/undergraduate">Undergraduate Applications</Link>}
      {canViewGraduate && <Link className="btn btn-primary" to="/graduate">
        {studentAccess?.graduateAccess ? 'Graduate Applications' : 'Graduate certificate Applications'}</Link>}
      {canManageAdministration && <>
        <Link className="btn btn-outline-primary" to="/impersonate">Impersonate User</Link>
        <Link className="btn btn-outline-primary" to="/admin/access">Manage Access</Link>
        <Link className="btn btn-outline-primary" to="/admin/email-templates">Email Templates</Link>
      </>}
    </div>
  </div>;
}

